<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Pembuatan DBKB Standar</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <select class="form-control" v-model="tab">
                            <option>AC</option>
                            <option>Boiler</option>
                            <option>Genset</option>
                            <option>Kolam Renang</option>
                            <option>Lapangan Tenis</option>
                            <option>Lift</option>
                            <option>Listrik</option>
                            <option>PABX</option>
                            <option>Pagar</option>
                            <option>Perkerasan</option>
                            <option>Proteksi Api</option>
                            <option>Sumur Artesis</option>
                            <option>Tangga Berjalan</option>
                        </select>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                 <div v-if ="tab == 'AC'">
                     <h3>AC</h3>
                    <bhumie_tab_ac></bhumie_tab_ac>
                </div>

                <div v-if ="tab == 'Boiler'">
                    <h3>Boiler</h3>
                    <bhumie_tab_boiler></bhumie_tab_boiler>
                </div>

                <div v-if ="tab == 'Genset'">
                    <h3>Genset</h3>
                    <bhumie_tab_genset></bhumie_tab_genset>
                </div>

                <div v-if ="tab == 'Kolam Renang'">
                    <h3>Kolam Renang</h3>
                    <bhumie_tab_kolam_renang></bhumie_tab_kolam_renang>
                </div>

                <div v-if ="tab == 'Lapangan Tenis'">
                    <h3>Lapangan Tenis</h3>
                    <bhumie_tab_lap_tenis></bhumie_tab_lap_tenis>
                </div>

                <div v-if ="tab == 'Lift'">
                    <h3>Lift</h3>
                    <bhumie_tab_lift></bhumie_tab_lift>
                </div>

                <div v-if ="tab == 'Listrik'">
                    <h3>Listrik</h3>
                    <bhumie_tab_listrik></bhumie_tab_listrik>
                </div>

                <div v-if ="tab == 'PABX'">
                    <h3>PABX</h3>
                    <bhumie_tab_pabx></bhumie_tab_pabx>
                </div>

                <div v-if ="tab == 'Pagar'">
                    <h3>Pagar</h3>
                    <bhumie_tab_pagar></bhumie_tab_pagar>
                </div>

                <div v-if ="tab == 'Perkerasan'">
                    <h3>Perkerasan</h3>
                    <bhumie_tab_perkerasan></bhumie_tab_perkerasan>
                </div>

                <div v-if ="tab == 'Proteksi Api'">
                    <h3>Proteksi Api</h3>
                    <bhumie_tab_proteksi_api></bhumie_tab_proteksi_api>
                </div>

                <div v-if ="tab == 'Sumur Artesis'">
                    <h3>Sumur Artesis</h3>
                    <bhumie_tab_sumur_artesis></bhumie_tab_sumur_artesis>
                </div>

                <div v-if ="tab == 'Tangga Berjalan'">
                    <h3>Tangga Berjalan</h3>
                    <bhumie_tab_tangga_berjalan></bhumie_tab_tangga_berjalan>
                </div>


        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/kecamatan/';


export default {
  name: "monev_kabupaten",
  data() {
    return {
        tab: 'AC',
    };
  },

// =============================================================== METHODS =========================================================================
  methods : {


  },
// =============================================================== METHODS =========================================================================

  mounted() {
    localStorage.sidemenu = 'bhumie';
  },
};
</script>
